module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1nNq0"))).then(() => parcelRequire('hEqeo'));